module.exports = __webpack_public_path__ + "static/img/winner_top.0b8a6b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winner_top.jpg
// module id = cu1x
// module chunks = 1